import type { ISignUpRequest } from '../types/SignUp';
import { EmailAlreadyInUseError } from './EmailAlreadyInUse';

/**
 * Whether this failed signup cost the office a referral as well as the account.
 *
 * True only when both hold: a referral code rode the attempt, and the reason it
 * failed is that the email already has a GoTu account. The generic failure copy
 * mentions only the email, so this is the signal to show the Account Exists
 * dialog in its place (GOTU-7434, mirroring mobile's GOTU-7313).
 *
 * One predicate, two readers — `useSignUp` uses it to stay silent so the generic
 * error modal does not stack under the dialog, and `SignUpForm` uses it to open
 * the dialog. They cannot disagree about which failure this is.
 *
 * Note what this deliberately is NOT: a pre-signup existence check. GOTU-7434's
 * dev notes looked for one and found only auth-service's `EmailStatus`, which
 * marks every office and DNT user `existing-user` and would fire on every new
 * customer. This reads the answer the create-user call already gave — a 409, via
 * `EmailAlreadyInUseError` — so it has no false-positive case at all.
 */
export const isReferralBlockedByExistingAccount = (
  error: unknown,
  request: Pick<ISignUpRequest, 'referredByCode'>,
): boolean => Boolean(request.referredByCode) && error instanceof EmailAlreadyInUseError;
